import { mergeClassnames } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';
import ItemText from '../ItemText';

type Props = {
  text: string;
  isHovered: boolean;
};

const Title: FC<Props> = ({ text, isHovered }) => (
  <ItemText
    className={mergeClassnames(isHovered ? 'text-piccolo' : 'text-bulma')}
  >
    <Translate id={text} />
  </ItemText>
);

export default Title;
